module.exports = __webpack_public_path__ + "img/event-report.42b40d7c.svg";